import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "header-document"
}
const _hoisted_2 = { class: "header-logo" }
const _hoisted_3 = {
  key: 1,
  class: "header-pages"
}
const _hoisted_4 = { class: "header-logo" }
const _hoisted_5 = { class: "header-actions" }
const _hoisted_6 = { class: "btn-actions" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Suporte direto no seu whatsapp", -1)
const _hoisted_8 = { class: "btn-actions" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Suporte direto no seu e-mail", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Acessar as configurações", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Voltar a página principal", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Sair")
const _hoisted_13 = { class: "header-actions-mobile" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Suporte por whatsapp ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("  Suporte por e-mail ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Configuração da conta ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Página Inicial ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Sair ")
const _hoisted_19 = { class: "action-mobile" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { style: {"margin-top":"20px","text-align":"right"} }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Cancelar ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Enviar ")
const _hoisted_24 = {
  key: 1,
  class: "modal-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoCertificata = _resolveComponent("LogoCertificata")!
  const _component_MenuOutlined = _resolveComponent("MenuOutlined")!
  const _component_WhatsAppOutlined = _resolveComponent("WhatsAppOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_MailOutlined = _resolveComponent("MailOutlined")!
  const _component_SettingOutlined = _resolveComponent("SettingOutlined")!
  const _component_HomeOutlined = _resolveComponent("HomeOutlined")!
  const _component_LogoutOutlined = _resolveComponent("LogoutOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_ToolOutlined = _resolveComponent("ToolOutlined")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!
  const _component_a_result = _resolveComponent("a-result")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isDocument)
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          _createElementVNode("section", _hoisted_2, [
            _createVNode(_component_LogoCertificata, { style: 'margin-left:10px' })
          ])
        ]))
      : (_openBlock(), _createElementBlock("header", _hoisted_3, [
          _createElementVNode("section", {
            class: "header-btn-responsive",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setDrawerMenu(true)))
          }, [
            _createVNode(_component_MenuOutlined)
          ]),
          _createElementVNode("section", _hoisted_4, [
            _createVNode(_component_LogoCertificata, { style: 'margin-top:0px;margin-left:10px' })
          ]),
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_a_tooltip, { placement: "top" }, {
                  title: _withCtx(() => [
                    _hoisted_7
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_WhatsAppOutlined, { onClick: _ctx.openSuporteWhats }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_a_tooltip, { placement: "top" }, {
                  title: _withCtx(() => [
                    _hoisted_9
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_MailOutlined, { onClick: _ctx.openSuporteMail }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              (!_ctx.isConfiguration)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "btn-actions",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.replace({ name: 'configuracao' })))
                  }, [
                    _createVNode(_component_a_tooltip, { placement: "top" }, {
                      title: _withCtx(() => [
                        _hoisted_10
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_SettingOutlined)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isConfiguration)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "btn-actions",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.replace({ name: 'home' })))
                  }, [
                    _createVNode(_component_a_tooltip, { placement: "top" }, {
                      title: _withCtx(() => [
                        _hoisted_11
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_HomeOutlined)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: "btn-actions",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, [
                _createVNode(_component_LogoutOutlined),
                _hoisted_12
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_13, [
            _createVNode(_component_a_dropdown, null, {
              overlay: _withCtx(() => [
                _createVNode(_component_a_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_menu_item, { key: "1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_WhatsAppOutlined, { onClick: _ctx.openSuporteWhats }, null, 8, ["onClick"]),
                        _hoisted_14
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_menu_item, { key: "2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_MailOutlined, { onClick: _ctx.openSuporteMail }, null, 8, ["onClick"]),
                        _hoisted_15
                      ]),
                      _: 1
                    }),
                    (!_ctx.isConfiguration)
                      ? (_openBlock(), _createBlock(_component_a_menu_item, {
                          key: "3",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.replace({ name: 'configuracao' })))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ToolOutlined),
                            _hoisted_16
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isConfiguration)
                      ? (_openBlock(), _createBlock(_component_a_menu_item, {
                          key: "3",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.replace({ name: 'home' })))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_HomeOutlined),
                            _hoisted_17
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_menu_item, {
                      key: "4",
                      onClick: _ctx.logout
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_LogoutOutlined),
                        _hoisted_18
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_19, [
                  _createVNode(_component_SettingOutlined),
                  _createVNode(_component_DownOutlined)
                ])
              ]),
              _: 1
            })
          ])
        ])),
    _createVNode(_component_a_modal, {
      visible: _ctx.suporteModalVisible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.suporteModalVisible) = $event)),
      title: _ctx.suporteSuccess ? null : 'Entrar em contato com o suporte',
      footer: null,
      width: "480px"
    }, {
      default: _withCtx(() => [
        (!_ctx.suporteSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_a_textarea, {
                value: _ctx.suporteMessage,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.suporteMessage) = $event)),
                rows: "5",
                placeholder: "Descreva aqui sua dúvida ou problema. Nossa equipe de suporte entrará em contato com você por e-mail"
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_a_button, {
                  style: {"margin-right":"8px"},
                  onClick: _ctx.closeSupportModal
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.sendSupportMail,
                  disabled: !_ctx.suporteMessage
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createVNode(_component_a_result, {
                class: "suporte-result",
                status: "success",
                title: "Sua solicitação foi registrada com sucesso!",
                "sub-title": "Nossa equipe de suporte entrará em contato por e-mail em breve."
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_CheckCircleFilled, { class: "ic" })
                ]),
                _: 1
              })
            ]))
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}